import SimpleStepper from './SimpleStepper';

export default SimpleStepper;
